import { useForm } from "react-hook-form";

import { CaseType } from "src/graphql/anti-fraud/__generated__/graphql.ts";

export type CaseTypeSelectionData = {
  selectedCaseType?: CaseType;
};

export const useCaseTypeSelection = () => {
  const methods = useForm<CaseTypeSelectionData>({
    defaultValues: {
      selectedCaseType: undefined,
    },
  });

  const selectedCaseType = methods.watch("selectedCaseType");

  const hasError = Object.keys(methods.formState.errors).length > 0;

  const submit = (callback: (data: CaseTypeSelectionData) => void) => {
    return methods.handleSubmit((data) => {
      callback(data);
    });
  };

  return {
    methods,
    selectedCaseType,
    hasError,
    submit,
  };
};
